import React from 'react';
import { ChatProvider } from '@/contexts/ChatContext';
import Header from './components/Header';
import CustomerOverview from './components/advisor/CustomerOverview';
import FunctionButtons from './components/advisor/FunctionButtons';
import MarketOverview from './components/advisor/MarketOverview';
import ChatSection from '@/components/ChatSection';
import * as ww from '@wecom/jssdk';
import Charts from './components/chat';
import { useHomePageTabs, useCopilotData, useHomePageScroll, useHomePageRefs } from './hooks';
import { WECOM_CORP_ID } from '@/config/env';
import { initWecom } from '@/utils/wecom';
// import { useAuth } from '@/contexts/AuthContext';

const HomePage: React.FC = () => {
  // const { followUserId, externalUserId } = useAuth();
  // 1. 管理所有 refs
  const { customerOverviewRef, headerRef, viewportRef, chartsViewportRef } = useHomePageRefs();

  // 2. 管理 Tab 切换逻辑
  const { activeTab, handleHeadClick, handleChatClick } = useHomePageTabs(headerRef);

  // 3. 管理 Copilot 数据获取和轮询
  const { loading, refresh } = useCopilotData(customerOverviewRef);

  // 4. 管理滚动逻辑
  const { scrollDown } = useHomePageScroll({
    activeTab,
    viewportRef,
    chartsViewportRef
  });

  // 增强的刷新函数，包含 Charts 组件的刷新
  const handleRefresh = () => {
    refresh();
  };

  const handleTest = async () => {
    await initWecom({
      corpId: WECOM_CORP_ID
    });
    ww.openEnterpriseChat({
      userIds: 'ideal',
      externalUserIds: 'wmICnAGQAAXZornDjE-kn5fk8RyZFzdQ'
    });
  };
  return (
    <ChatProvider chartsViewportRef={chartsViewportRef}>
      <div className="relative mx-auto min-h-screen w-full">
        {/* 头部导航 */}
        <button onClick={handleTest} className="hidden">
          测试
        </button>
        <Header
          ref={headerRef}
          refresh={handleRefresh}
          handleHeadClick={handleHeadClick}
          isShowBack={false}
          inntActiveTab={activeTab}
          showRefresh={activeTab !== 1}
        />

        {/* 投顾应用区域 */}
        {activeTab === 0 && (
          <div
            className={`relative h-[calc(100vh-84px-50px)] overflow-y-auto transition-opacity duration-300`}
            style={{ display: activeTab === 0 ? 'block' : 'none' }}
            ref={viewportRef}
          >
            {/* {isLoading && (
              <div className="absolute left-0 top-0 z-[1000] flex h-full w-full items-center justify-center">
                <SkeletonDashboard className="absolute left-0 top-0 w-full" />
              </div>
            )} */}
            <div className={`space-y-4 px-4 pb-40 transition-opacity duration-300`}>
              {/* 客户概览卡片 */}
              <CustomerOverview
                ref={customerOverviewRef}
                loading={loading.userProfile || loading.extendedProfile}
              />

              {/* 功能按钮区域 */}
              <FunctionButtons />

              {/* 市场动态 */}
              <MarketOverview />
            </div>
          </div>
        )}

        {/* 图表区域 */}
        {activeTab === 1 && (
          <div
            className="relative h-[calc(100vh-84px-50px)] space-y-4 overflow-y-auto px-4 pb-40"
            style={{ display: activeTab === 1 ? 'block' : 'none' }}
            ref={chartsViewportRef}
          >
            <Charts />
          </div>
        )}

        {/* 底部聊天区域 */}
        <ChatSection scrollDown={scrollDown} setActiveTab={handleChatClick} />
      </div>
    </ChatProvider>
  );
};

export default HomePage;
